














































import { Component, Vue } from 'vue-property-decorator';
import { Store } from 'vuex';
import {readBooks} from '@/store/courses/getters';
import {dispatchGetBooks, dispatchPurchaseBook} from '@/store/courses/actions';
import PageSeparator from '../../../components/vui-luma/Ui/PageSeparator.vue';
import CourseCard from '../../../components/vui-luma/Course/CourseCard.vue';
import PageHeadline from '../../../components/vui-luma/Ui/PageHeadline.vue';
import CustomSelectInput from '../../../components/vui-luma/Ui/CustomSelectInput.vue';
// @ts-ignore
import logo from '@/assets/images/logo.png';
import pdf from 'vue-pdf';
import { ICartPayment } from '@/interfaces';
import { StripeCheckout } from '@vue-stripe/vue-stripe';

@Component({
  components: {
      CustomSelectInput,
      CourseCard,
      PageSeparator,
      PageHeadline,
      pdf,
      StripeCheckout,
  },
})
export default class Books extends Vue {
  public containerClass = 'container page__container';
  public prevControl = false;
  public commentBody = '';
  public logo = logo;
  public cartPayment: ICartPayment | null = null;

  public async mounted() {
    await dispatchGetBooks(this.$store);
  }

  get books() {
    return readBooks(this.$store);
  }

  public async submitPurchaseBook(book) {
    const response = await dispatchPurchaseBook(this.$store, { book });
    if (response && response.payment_method === 'stripe') {
      this.cartPayment = response;
      // @ts-ignore
      setTimeout(()=>{this.$refs.checkoutRef.redirectToCheckout();}, 100);
    }
    // if (link !== '') {
    //   const element = document.createElement('a');
    //   element.href = link;
    //   setTimeout(() => {
    //     element.click();
    //     }, 200);
    // }
  }

}
